<ion-content class="ion-padding">
  <div class="container">
    <div>

      <div class="ion-text-center ion-padding ion-margin-top">
        <img class="logo" src="assets/image/IMS-app_logo_mit_subline.svg" />
      </div>
      
      <ion-card>
        <ion-card-header class="ion-no-padding ion-padding-top">
          <ion-card-title class="ion-text-center">
            {{ 'PAGE.TOKEN-ID.HEADER' | translate }}
          </ion-card-title>
        </ion-card-header>
        <ion-card-content
          class="ion-no-padding ion-padding-horizontal ion-padding-bottom"
        >
          <br />
          <div>
            <ion-text>
              {{ 'PAGE.TOKEN-ID.SUBHEADER' | translate }}
            </ion-text>
          </div>
          <br />
          <div>
            <ion-text>
              {{ 'PAGE.TOKEN-ID.DESCRIPTION' | translate }}
            </ion-text>
          </div>
          <br />
          <!-- 
            ion-no-padding makes the underline of the ion-item without the 
            padding on the left 
          -->
          <ion-item class="ion-no-padding">
            <ion-input
              id="tkn"
              name="tkn"
              class="form-control"
              required
              [(ngModel)]="token"
              #tkn="ngModel"
              type="text"
              pattern="[0-9]{8,8}"
              inputmode="numeric"
              autocomplete="one-time-code"
              placeholder="{{ 'PAGE.TOKEN-ID.PLACEHOLDER' | translate }}"
              (ionChange)="codeChanged()"
            ></ion-input>
          </ion-item>

          <div *ngIf="tkn.invalid && (tkn.dirty || tkn.touched)">
            <ion-text color="danger" *ngIf="tkn.errors.required">
              {{ 'PAGE.TOKEN-ID.REQUIRED' | translate }}
            </ion-text>
            <ion-text color="danger" *ngIf="tkn.errors.pattern">
              {{ 'PAGE.TOKEN-ID.PATTERN' | translate }}
            </ion-text>
          </div>

          <div *ngIf="errorMessage">
            <ion-text color="danger">
              {{ 'PAGE.TOKEN-ID.ERROR' | translate }} ({{ errorMessage |
              translate }} <span *ngIf="statusCode">- {{ statusCode }}</span>)
            </ion-text>
          </div>
          <div *ngIf="errorDetail">
            <ion-text color="danger">
              {{ errorDetail }}
            </ion-text>
          </div>

          <ion-button
            expand="block"
            class="ion-margin-top"
            (click)="save()"
            [disabled]="tkn.invalid"
          >
            <ion-text>
              {{ 'PAGE.TOKEN-ID.SAVE' | translate }}
            </ion-text>
          </ion-button>
        </ion-card-content>
      </ion-card>

      <div class="ion-text-center ion-padding">
        <a (click)="resend()">
          {{ 'PAGE.TOKEN-ID.RESEND' | translate }}
        </a>
      </div>

      <div class="ion-text-center ion-padding">
        <a (click)="troubleshooting()">
          {{ 'PAGE.TOKEN-ID.TROUBLE' | translate }}
        </a>
      </div>

      <div class="ion-text-center ion-padding">
        <a (click)="logout()">
          {{ 'PAGE.TOKEN-ID.LOGOUT' | translate }}
        </a>
      </div>
    </div>
  </div>
</ion-content>
